<template>
  <div ref="container" class="onboarding-signup__slider">
    <SignupBannerItem
      v-for="page in onboardingPages.intro"
      :key="page.title"
      :page="page"
    />
  </div>

  <div class="onboarding-signup__dots">
    <button
      v-for="(page, index) in onboardingPages.intro"
      :key="index"
      class="onboarding-signup__dot"
      :class="{
        'onboarding-signup__dot--active': currentPosition === index,
      }"
      @click="changeSlide(index)"
    />
  </div>
</template>

<script setup lang="ts">
import { onboardingPages } from '@/models/onboarding.pages'

import SignupBannerItem from './SliderItem.vue'

import { ref, onMounted, onUnmounted } from 'vue'

const currentPosition = ref(0)
const container = ref<HTMLElement | null>(null)

const changeSlide = (newPosition: number): void => {
  if (!container.value) {
    return
  }

  container.value.scrollTo({
    left: newPosition * ((container.value.scrollWidth - 20) / 3),
    behavior: 'smooth',
  })

  currentPosition.value = newPosition
}

const handleScroll = (): void => {
  if (!container.value) {
    return
  }

  const scrollPosition = container.value.scrollLeft
  const slideWidth = (container.value.scrollWidth - 20) / 3
  const newPosition = Math.round(scrollPosition / slideWidth)

  currentPosition.value = newPosition
}

onMounted(() => {
  container.value?.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  container.value?.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss" scoped>
.onboarding-signup {
  &__slider {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    width: 100%;
    min-height: 0;

    &::-webkit-scrollbar {
      display: none;
    }

    @media only screen and (max-width: $w-tablet-s) {
      margin-top: 12px;
    }
  }

  &__dots {
    display: flex;
    gap: 4px;
    justify-content: center;
    margin-top: 28px;
    @media only screen and (max-width: $w-tablet-s) {
      margin-top: 12px;
    }
  }

  &__dot {
    background: $c-border-7;
    height: 6px;
    width: 6px;
    border-radius: 50%;

    &--active {
      background: $c-yellow;
    }
  }
}
</style>
